// The dust's scene running on a canvas (presenceScene.js). The built homepage
// starts it with a small script of its own (presenceBoot.js) and React's
// PresenceField.jsx takes it over: they come in two bundles, so the scene is
// kept on the canvas, under a name both know.
const RUNNING = Symbol.for("avrah.presence");

export const runningOn = (canvas) => canvas[RUNNING] ?? null;

export const setRunning = (canvas, scene) => {
  canvas[RUNNING] = scene;
};
